/**
 * User: daletan
 * Date: 9/25/15
 * Time: 6:26 PM
 * Copyright 1stdibs.com, Inc. 2015. All Rights Reserved.
 */

'use strict';

module.exports = Object.freeze({
    height: 'height',
    width: 'width',
    depth: 'depth',
    condition: 'condition',
    length: 'length',
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/constants/schemaTypes.js
// module id = 1340
// module chunks = 4 14